import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import dialogTypes from 'src/js/modules/dialogs/constants/dialog-types';
import { i18next, site, dialogs } from '@yola/ws-sdk';
import { SubmitDialog } from '@yola/ws-ui';
import saveSite from 'src/js/modules/saving/helpers/save-site';
import performFolderDelete from '../helpers/perform-folder-delete';

const getCaptions = ({ folderName }) => ({
  title: i18next.t('Delete {folderName}?', {
    folderName,
  }),
  description: i18next.t("This deletes the folder and all pages inside it. You can't undo this."),
  submit: i18next.t('Submit'),
  cancel: i18next.t('Cancel'),
  discard: i18next.t(''),
});

function FolderDeleteContainer({
  folderId,
  folderName,
  itemType,
  bulkEditing,
  itemsCount,
  onDialogMainAction,
  onDialogCancel,
}) {
  const dispatch = useDispatch();
  const activePageId = useSelector(site.selectors.getActivePageId);
  const pages = useSelector(site.selectors.getPages);

  const captions = getCaptions({ folderName });

  const handleCancel = () => {
    onDialogCancel({
      itemType,
      bulkEditing,
      itemsCount,
    });
    dispatch(dialogs.actions.show(dialogTypes.PAGE_MANAGER));
  };

  const handleSubmit = async () => {
    onDialogMainAction({
      itemType,
      bulkEditing,
      itemsCount,
    });

    await performFolderDelete({ folderId, pages, activePageId });
    saveSite();
    dispatch(dialogs.actions.show(dialogTypes.PAGE_MANAGER));
  };

  return <SubmitDialog captions={captions} onSubmit={handleSubmit} onCancel={handleCancel} />;
}

FolderDeleteContainer.propTypes = {
  folderId: PropTypes.string.isRequired,
  folderName: PropTypes.string.isRequired,
  itemType: PropTypes.string.isRequired,
  bulkEditing: PropTypes.bool.isRequired,
  itemsCount: PropTypes.number.isRequired,
  onDialogMainAction: PropTypes.func.isRequired,
  onDialogCancel: PropTypes.func.isRequired,
};

export default FolderDeleteContainer;
